module.exports = "<!--TODO(avatars): fix class definitions in Sass-->\r\n<avatar\r\n  class=\"icon user-icon\"\r\n  ng-class=\"personItem.presenceClass\"\r\n  model=\"personItem.delegate\"\r\n  target-width=\"'44'\"\r\n  target-height=\"'44'\"\r\n  crop-target=\"true\">\r\n</avatar>\r\n<h2>{{personItem.delegate.name}}</h2>\r\n<span ng-if=\"personItem.person.role\" class=\"secondary\">\r\n  <span>{{personItem.person.role}}</span>\r\n</span>";


//////////////////
// WEBPACK FOOTER
// ./src/js/personnel/directives/person-item-directive.html
// module id = 3486
// module chunks = 0